<template>
  <div>
    <param-card
      linkTo="paikkakunta"
      :iconUrl="require('../assets/param/common_location.png')"
      :label="'room.param.town.title' | i18n"
      :value="townName" />

    <param-card
      linkTo="pohjamuoto"
      :iconUrl="shapeIcon"
      :label="'room.param.shape.title' | i18n"
      :value="shapeLabel" />

    <param-card
      linkTo="ala"
      :iconUrl="require('../assets/param/common_area.png')"
      :label="'room.param.area.title' | i18n"
      :value="area | formatNumber" unit="hum2" />

    <param-card
      linkTo="korkeus"
      :iconUrl="require('../assets/param/common_height.png')"
      :label="'room.param.height.title' | i18n"
      :value="height | formatNumber" unit="m" />

    <param-card
      linkTo="valiovet"
      :iconUrl="require('../assets/param/room_doors.png')"
      :label="'room.param.doors.title' | i18n"
      :value="numOfDoors" unit="kpl" />

    <param-card
      linkTo="ikkunat"
      :iconUrl="require('../assets/param/room_windows.png')"
      :label="'room.param.windows.title' | i18n"
      :value="numOfWindowsStr" />
  </div>
</template>


<script>
  import Vue from 'vue'
  import { mapState, mapActions, mapGetters } from 'vuex'
  import ParamCard from './ParamCard'
  import { roomShapes, defaultRoomShape } from "../api/constants";

  export default {
    computed: {
      ...mapGetters('roomParams', [
        'numOfWindowsStr'
      ]),

      ...mapState('roomParams', {
        area: state => state.area,
        height: state => state.height,
        shape: state => state.shape,
        numOfDoors: state => state.numOfDoors,

        shapeLabel: state => state.shape != null ? state.shape.label : null,
        shapeIcon: state => state.shape != null ? state.shape.icon : defaultRoomShape.icon,

        townName: state => (state.town != null ? (state.town.stateName + '|' + state.town.name) : null)
      })
    },

    components: {
      ParamCard
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/RoomParams.vue